module.exports = __webpack_public_path__ + "img/img_fakao.611e3019.jpg";